import { createFileRoute } from '@tanstack/react-router';
import { PayoutAddTransferPage } from '../components/pages/PayoutTransferCreatePage/PayoutAddTransferPage';
import { z } from 'zod/mini';

const searchSchema = z.object({
  createdAt: z.catch(z.string(), ''),
  accountId: z.optional(z.string()),
});

export const Route = createFileRoute('/account/payouts_/$payoutId_/create')({
  component: PayoutAddTransferPage,
  validateSearch: searchSchema.parse,
});
